import { useTranslation } from 'react-i18next';

import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '../i18n';

const LABELS: Record<SupportedLanguage, string> = {
  es: 'Español',
  en: 'English',
  pt: 'Português'
};

const FLAGS: Record<SupportedLanguage, string> = {
  es: '🇪🇸',
  en: '🇺🇸',
  pt: '🇧🇷'
};

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = (i18n.language as SupportedLanguage) ?? 'es';

  return (
    <div className="langswitch" role="group" aria-label={t('common.language')}>
      {SUPPORTED_LANGUAGES.map((lng) => (
        <button
          key={lng}
          type="button"
          className={`langswitch__btn${current === lng ? ' is-active' : ''}`}
          aria-pressed={current === lng}
          aria-label={LABELS[lng]}
          title={LABELS[lng]}
          onClick={() => void i18n.changeLanguage(lng)}
        >
          <span aria-hidden="true">{FLAGS[lng]}</span>
        </button>
      ))}
    </div>
  );
}
